import { BaseGraphicsProvider } from "elements/base/graphics";
import { ResizeType } from "elements/base/types";
import { TaskElement } from "./schema";
import { StandardAnchorPoints } from "frontend/canvas-designer-new/elements/connector/anchor-point-utils";
import { CanvasElementBox, Degrees } from "utils/transform";
import { TASK_HEIGHT, TASK_WIDTH } from "shared/datamodel/task";

export default class TaskGraphicsProvider extends BaseGraphicsProvider<TaskElement> {
  getConnectorAnchorPoints(element: TaskElement): StandardAnchorPoints | null {
    const { x, y, width = TASK_WIDTH, height = TASK_HEIGHT, scaleX = 1, scaleY = 1 } = element;
    const scaledWidth = width * scaleX;
    const scaledHeight = height * scaleY;

    const bottomPadding = 4; // Overlaps shape a little due to shadow
    const anchors = {
      top: { x: x + scaledWidth / 2, y, rotation: 270 as Degrees, onBoundingBox: true },
      right: { x: x + scaledWidth, y: y + scaledHeight / 2, rotation: 0 as Degrees, onBoundingBox: true },
      buttom: {
        x: x + scaledWidth / 2,
        y: y + scaledHeight + bottomPadding,
        rotation: 90 as Degrees,
        onBoundingBox: true,
      },
      left: { x, y: y + scaledHeight / 2, rotation: 180 as Degrees, onBoundingBox: true },
    };
    return anchors;
  }

  getResizeType(): ResizeType {
    return ResizeType.All;
  }

  getTransformParams(element: TaskElement): CanvasElementBox {
    // We take into account the border for the total bounding box height
    const borderHeight = 4;

    return {
      x: element.x,
      y: element.y,
      width: element.width * (element.scaleX ?? 1),
      height: (element.height + borderHeight) * (element.scaleY ?? 1),
    };
  }

  getLinkBadgePosition(element: TaskElement) {
    // Compensate for weird built-in margins on the badge
    return { x: element.width + 10, y: element.height + 10 };
  }
}
